/* eslint-disable */
(function () {
  if (window.WoodeexProductBundleLoaded) return;
  window.WoodeexProductBundleLoaded = true;

  function getSelectedVariantControl(card) {
    return card.querySelector('[data-bundle-variant-select]');
  }

  function getSelectedVariantData(card) {
    var control = getSelectedVariantControl(card);
    if (!control) return null;

    if (control.tagName === 'SELECT') {
      var option = control.options[control.selectedIndex];
      if (!option) return null;

      return {
        id: option.value,
        price: option.dataset.price || '',
        available: option.dataset.available === 'true',
        image: option.dataset.image || '',
        image2x: option.dataset.image2x || ''
      };
    }

    return {
      id: control.value,
      price: control.dataset.price || '',
      available: control.dataset.available === 'true',
      image: control.dataset.image || '',
      image2x: control.dataset.image2x || ''
    };
  }

  function updateCard(card) {
    var data = getSelectedVariantData(card);
    if (!data) return;

    var hiddenInput = card.querySelector('[data-bundle-variant-id]');
    var priceEl = card.querySelector('[data-bundle-price]');
    var imageEl = card.querySelector('[data-bundle-image]');
    var toggle = card.querySelector('[data-bundle-toggle]');
    var availabilityEl = card.querySelector('[data-bundle-availability]');

    if (hiddenInput) hiddenInput.value = data.id;
    if (priceEl && data.price) priceEl.textContent = data.price;

    if (imageEl && data.image) {
      imageEl.src = data.image;
      imageEl.srcset = data.image2x ? data.image + ' 1x, ' + data.image2x + ' 2x' : data.image;
    }

    card.classList.toggle('is-unavailable', !data.available);

    if (toggle) {
      toggle.disabled = !data.available;
      if (!data.available) toggle.checked = false;
      card.classList.toggle('is-enabled', toggle.checked && data.available);
    }

    if (availabilityEl) {
      availabilityEl.hidden = data.available;
    }
  }

  function updateToggleState(toggle) {
    var card = toggle.closest('[data-bundle-card]');
    if (!card) return;

    var data = getSelectedVariantData(card);
    card.classList.toggle('is-enabled', toggle.checked && data && data.available);
  }

  function getBundleItems(bundle, mainQuantity) {
    var sameQuantity = bundle.dataset.sameQuantity === 'true';
    var parentTitle = bundle.dataset.parentProductTitle || '';
    var quantity = sameQuantity ? mainQuantity : 1;
    var items = [];

    bundle.querySelectorAll('[data-bundle-card]').forEach(function (card) {
      var toggle = card.querySelector('[data-bundle-toggle]');
      var variantInput = card.querySelector('[data-bundle-variant-id]');
      var data = getSelectedVariantData(card);

      if (!toggle || !variantInput || !toggle.checked || toggle.disabled || !data || !data.available) return;

      items.push({
        id: Number(variantInput.value),
        quantity: quantity,
        properties: {
          '_Bundle': 'true',
          '_Bundle parent': parentTitle
        }
      });
    });

    return items;
  }

  function getMainProperties(form) {
    var properties = {};
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') {
        properties[match[1]] = value;
      }
    });

    return properties;
  }

  function getMainSellingPlan(form) {
    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    return sellingPlanInput && sellingPlanInput.value ? Number(sellingPlanInput.value) : null;
  }

  function getMainQuantity(form) {
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function setFormLoading(form, isLoading) {
    var button = form.querySelector('[name="add"]');
    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  function showError(form, message) {
    var errorEl = form.closest('product-form')
      ? form.closest('product-form').querySelector('.js-form-error')
      : form.querySelector('.js-form-error');

    if (!errorEl) {
      window.alert(message);
      return;
    }

    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form.js-product-form')) return;

    var section = form.closest('.js-product');
    if (!section) return;

    var bundle = section.querySelector('[data-woodeex-product-bundle]');
    if (!bundle) return;

    var mainIdInput = form.querySelector('[name="id"]');
    if (!mainIdInput || !mainIdInput.value) return;

    var mainQuantity = getMainQuantity(form);
    var bundleItems = getBundleItems(bundle, mainQuantity);
    if (!bundleItems.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var mainItem = {
      id: Number(mainIdInput.value),
      quantity: mainQuantity
    };

    var properties = getMainProperties(form);
    if (Object.keys(properties).length) mainItem.properties = properties;

    var sellingPlan = getMainSellingPlan(form);
    if (sellingPlan) mainItem.selling_plan = sellingPlan;

    var items = [mainItem].concat(bundleItems);
    var submitter = event.submitter;
    var redirectUrl = submitter && submitter.dataset ? submitter.dataset.url : '';
    var redirectToCart = bundle.dataset.redirectToCart !== 'false';

    setFormLoading(form, true);

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw new Error(error.description || error.message || 'Erreur lors de l’ajout au panier.');
          });
        }
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else if (redirectToCart) {
          window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
        } else {
          setFormLoading(form, false);
        }
      })
      .catch(function (error) {
        setFormLoading(form, false);
        showError(form, error.message || 'Erreur lors de l’ajout au panier.');
      });
  }

  function init(root) {
    root.querySelectorAll('[data-woodeex-product-bundle]').forEach(function (bundle) {
      bundle.querySelectorAll('[data-bundle-card]').forEach(updateCard);
    });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-bundle-variant-select]');
    if (select) {
      var card = select.closest('[data-bundle-card]');
      if (card) updateCard(card);
      return;
    }

    var toggle = event.target.closest('[data-bundle-toggle]');
    if (toggle) updateToggleState(toggle);
  });

  document.addEventListener('submit', handleSubmit, true);

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();